import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import _toString from 'lodash/toString';
import _size from 'lodash/size';
import _find from 'lodash/find';
import PropTypes from 'prop-types';
// Models
import mDoor from 'models/door';
// Custom
import { deviceSlaveRelayDataShape, doorDataShape } from 'constants/PropTypesShapes';
import InformationItem from 'components/items/InformationItem';

const RelayItem = ({ relay, initiallyOpen, doors }) => {
  const relayDoors = relay.doors;
  let icon = 'itemNothing';
  let value = <LocalizedMessage id="info.relayNotLinked" />;
  let nestedDoors;
  // Display relay doors
  const nbDoors = _size(relayDoors);
  if (!!doors && nbDoors > 0) {
    if (nbDoors === 1) {
      const door = _find(doors, { id: relayDoors[0] });
      icon = mDoor.usage(door).icon;
      value = <LocalizedMessage id="info.relayLinkedToDoor" values={{ door: door.name }} />;
    } else {
      value = <LocalizedMessage id="info.relayLinkedToNbDoors" values={{ nbDoors }} />;
      nestedDoors = _map(relayDoors, (doorId) => {
        const door = _find(doors, { id: doorId });
        return ({
          key: _toString(door.id),
          icon: mDoor.usage(door).icon,
          label: <LocalizedMessage id={`door.type.${door.type}`} />,
          value: door.name,
        });
      });
      if (nbDoors < 10) {
        icon = `itemMultiple${nbDoors}`;
      } else {
        icon = 'itemMultiple9Plus';
      }
    }
  }

  return (
    <InformationItem
      label={<LocalizedMessage id="info.relay" values={{ relay: relay.code }} />}
      value={value}
      icon={icon}
      withAvatar
      initiallyOpen={initiallyOpen}
      nestedItems={nestedDoors}
    />
  );
};

RelayItem.propTypes = {
  relay: deviceSlaveRelayDataShape.isRequired,
  initiallyOpen: PropTypes.bool,
  doors: PropTypes.arrayOf(doorDataShape),
};

RelayItem.defaultProps = {
  initiallyOpen: false,
  doors: null,
};

const mapStateToProps = (state) => ({
  doors: state.installationDoor.list.elements,
});

module.exports = connect(
  mapStateToProps,
  null,
)(RelayItem);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/configuration/RelayItem.js